
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M58.472 14.575c-.642-2.527-2.743-4.47-5.363-4.946a147.394 147.394 0 00-23.333-1.616c-7.75-.11-15.569.489-23.21 1.766l-.491.163c-1.078.394-4.353 1.59-4.871 4.891A81.99 81.99 0 00.017 29.751a58.46 58.46 0 001.65 15.231c.642 2.527 2.743 4.47 5.268 4.932 4.898 1.114 13.55 1.78 23.128 1.78h1.214c7.3 0 14.655-.598 21.86-1.767l.327-.095c1.119-.366 4.503-1.508 5.049-4.959.846-5 1.35-10.122 1.487-15.244a83.955 83.955 0 00-1.528-15.054zm-2.675 29.863c-.245 1.59-1.773 2.337-3.22 2.826a134.125 134.125 0 01-22.514 1.712c-9.388 0-17.807-.638-22.596-1.725-1.542-.285-2.784-1.427-3.166-2.921a55.453 55.453 0 01-1.57-14.565 79.62 79.62 0 011.16-14.497c.246-1.549 1.802-2.296 3.125-2.786l.123-.054a128.631 128.631 0 0122.61-1.712h.027c7.669-.081 15.35.462 22.87 1.576 1.541.286 2.783 1.427 3.151 2.867a78.019 78.019 0 011.433 14.43c-.11 4.958-.6 9.945-1.433 14.85z"}}),_c('path',{attrs:{"d":"M41.566 28.596L23.8 18.488a1.394 1.394 0 00-1.365 0 1.362 1.362 0 00-.682 1.182v20.217c0 .489.26.937.682 1.182.219.122.45.177.683.177.232 0 .463-.055.682-.177L41.566 30.96c.423-.244.682-.693.682-1.182s-.26-.937-.682-1.182zm-17.07 8.954V22.02l13.645 7.758-13.645 7.772z"}})])
          )
        }
      }
    